/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'cancel-info': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M129.6 830.8V193.2h637.6V257h127.6V97.6c0-17.6-14.2-31.8-31.8-31.8l-828.6.4C16.8 66.2 2 80 2 97.6v828.8c0 17.6 14.2 31.8 31.8 31.8h286.8V830.6h-191zm882.8 71.6l-46.2 46.2a32.592 32.592 0 01-46.2 0L735.2 763.8 550.4 948.6a32.592 32.592 0 01-46.2 0L458 902.4a32.592 32.592 0 010-46.2l184.8-184.8L458 486.6a32.592 32.592 0 010-46.2l46-46.4c12.8-12.8 33.4-12.8 46.2 0L735 578.8 920 394c12.8-12.8 33.4-12.8 46.2 0l46.2 46.2c12.8 12.8 12.8 33.4 0 46.2L827.6 671.2 1012.4 856c12.8 13 12.8 33.6 0 46.4zm0 0"/>'
  }
})
